export const DEFAULT_GOAL_GENERAL_FEEDBACK = "__GENERAL_FEEDBACK__"
export const DEFAULT_GOAL_GENERAL_FEEDBACK_SLUG = "general-feedback"
export const DEFAULT_GOAL_NPS = "__NPS__"
export const DEFAULT_GOAL_NPS_SLUG = "nps"
export const DEFAULT_GOAL_PRODUCT_QUALITY = "__PRODUCT_QUALITY__"
export const DEFAULT_GOAL_PRODUCT_QUALITY_SLUG = "product-quality"
export const DEFAULT_GOAL_CHECKOUT_EXPERIENCE = "__CHECKOUT_EXPERIENCE__"
export const DEFAULT_GOAL_CHECKOUT_EXPERIENCE_SLUG = "checkout-experience"
export const DEFAULT_GOAL_STORE_EXPERIENCE = "__STORE_EXPERIENCE__"
export const DEFAULT_GOAL_STORE_EXPERIENCE_SLUG = "store-experience"

// Demo goals
export const DEFAULT_GOAL_PURCHASE_ORDER_EXPERIENCE = "__PURCHASE_ORDER_EXPERIENCE__"
export const DEFAULT_GOAL_PRODUCT_EXPERIENCE = "__PRODUCT_EXPERIENCE__"
export const DEFAULT_GOAL_SHOPPING_AND_DELIVERY_EXPERIENCE = "__SHOPPING_AND_DELIVERY_EXPERIENCE__"
export const DEFAULT_GOAL_BRAND_PERCEPTION_AND_AFFINITY = "__BRAND_PERCEPTION_AND_AFFINITY__"
export const DEFAULT_GOAL_SUPPORT_QUERY_RESOLUTION = "__SUPPORT_QUERY_RESOLUTION__"

export const isDefaultGoal = (goalName: string) => {
  return [
    DEFAULT_GOAL_GENERAL_FEEDBACK,
    DEFAULT_GOAL_NPS,
    DEFAULT_GOAL_PRODUCT_QUALITY,
    DEFAULT_GOAL_CHECKOUT_EXPERIENCE,
    DEFAULT_GOAL_STORE_EXPERIENCE,
    DEFAULT_GOAL_PURCHASE_ORDER_EXPERIENCE,
    DEFAULT_GOAL_PRODUCT_EXPERIENCE,
    DEFAULT_GOAL_SHOPPING_AND_DELIVERY_EXPERIENCE,
    DEFAULT_GOAL_BRAND_PERCEPTION_AND_AFFINITY,
    DEFAULT_GOAL_SUPPORT_QUERY_RESOLUTION,
  ].includes(goalName)
}
